export enum VerificationStatus {
	rejectNoUserData = 'rejectNoUserData',
	rejectWithUserData = 'rejectWithUserData',
	successNotSameDeviceWeb = 'successNotSameDeviceWeb',
	successNotSameDeviceApp = 'successNotSameDeviceApp',
}

export enum WelcomeStep {
	login = 'login',
	registration = 'registration',
	verifyEmail = 'verifyEmail', //comes from an email link, "Verify email" button
	forgotPassword = 'forgotPassword',
	resetPassword = 'resetPassword',
	verifyBeforeStart = 'verifyBeforeStart',
	personalDetails = 'personalDetails',
	tryOurApp = 'tryOurApp',
	verifyAndChangeEmail = 'verifyAndChangeEmail',
}
